import { Modal, CloseIcon2 } from "../Modal";
import { ItemModalItem } from "./item-modal-item";
import { Step } from "constants/mall";
import { useEffect, useState } from "react";
import { ItemModalOrder } from "./item-modal-order";
import { useRouter } from "next/router";
import classNames from "classnames";
import { useWindowHeight } from "../../hooks";

export const ItemModal = ({ item, isHolder, onClose, cupPointsInfo }) => {
  const [step, setStep] = useState(Step.item);
  const { locale } = useRouter();
  const { windowHeight } = useWindowHeight();

  const title = locale === "cn" ? item.goodsName : item.overseaName;
  const desc = locale === "cn" ? item.desc : item.overseaDesc;

  console.log("ItemModal", { item });

  return (
    <Modal
      style={{ backgroundColor: "transparent", borderRadius: 40 }}
      closeIcon={
        <CloseIcon2
          className={classNames({
            "translate-y-[-5px]": step === Step.order,
          })}
        />
      }
      onClose={onClose}
    >
      {step === Step.item && (
        <ItemModalItem
          item={item}
          title={title}
          desc={desc}
          isHolder={isHolder}
          cupPointsInfo={cupPointsInfo}
          onRedeem={() => {
            setStep(Step.order);
          }}
        />
      )}
      {step === Step.order && (
        <ItemModalOrder
          item={item}
          title={title}
          desc={desc}
          windowHeight={windowHeight}
        />
      )}
    </Modal>
  );
};
